"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var FiltersIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", { fill: "none" },
        React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M20 6.97729597C20 7.54203314 19.5884138 8 19.0804598 8L4.91954023 8C4.41158621 8 4 7.54203314 4 6.97729597L4 6.02270403C4 5.45796686 4.41158621 5 4.91954023 5L19.0804598 5C19.5884138 5 20 5.45796686 20 6.02270403L20 6.97729597zM17 11.9772262C17 12.5422065 16.6073684 13 16.122807 13L7.87719298 13C7.39263158 13 7 12.5422065 7 11.9772262L7 11.0227738C7 10.4577935 7.39263158 10 7.87719298 10L16.122807 10C16.6073684 10 17 10.4577935 17 11.0227738L17 11.9772262zM15 16.977296C15 17.5420331 14.5026667 18 13.8888889 18L10.1111111 18C9.49733333 18 9 17.5420331 9 16.977296L9 16.022704C9 15.4579669 9.49733333 15 10.1111111 15L13.8888889 15C14.5026667 15 15 15.4579669 15 16.022704L15 16.977296z" })))); };
exports.FiltersIcon = FiltersIcon;
